import { Tab } from "@remo-co/ui-core/src/components/Tab";
import { Tabs } from "@remo-co/ui-core/src/components/Tabs";
import { useI18n } from "i18n";
import { EventEmailCustomizationType } from "modules/emailCustomization/types";
import { styles } from "./styles";

interface Props {
  selectedTab: string;
  onChange: (tab: EventEmailCustomizationType) => void;
}

export const EmailCustomizationTabGroup = ({
  selectedTab,
  onChange,
}: Props) => {
  const { t } = useI18n(["eventForm"]);

  return (
    <Tabs
      value={selectedTab}
      indicatorColor="primary"
      textColor="primary"
      sx={styles.tabs}
      onChange={(_, tab: EventEmailCustomizationType) => onChange(tab)}
    >
      <Tab
        disableRipple
        label={t("eventForm:customize.emails.invite.tab")}
        id="tab-invite"
        sx={styles.tab}
        value={EventEmailCustomizationType.INVITE}
      />
      <Tab
        disableRipple
        label={t("eventForm:customize.emails.registration.tab")}
        id="tab-registration"
        sx={styles.tab}
        value={EventEmailCustomizationType.REGISTRATION_CONFIRMATION}
      />
      <Tab
        disableRipple
        label={t("eventForm:customize.emails.day.reminder.tab")}
        id="tab-days-reminder"
        sx={styles.tab}
        value={EventEmailCustomizationType.DAYS_REMINDER}
      />
      <Tab
        disableRipple
        label={t("eventForm:customize.emails.mins.reminder.tab")}
        id="tab-mins-reminder"
        sx={styles.tab}
        value={EventEmailCustomizationType.MINUTES_REMINDER}
      />
    </Tabs>
  );
};
